/*
  Actual application starts from this file
*/

import React, { useState } from 'react';
import {
  BrowserRouter,
  Switch,
  Route
} from 'react-router-dom'; //https://css-tricks.com/the-hooks-of-react-router/
import Loadable from 'react-loadable';

// Redux
import { useSelector } from 'react-redux';
import { userPermissions } from 'store/actions/AuthAction';

// Antd
import { notification } from 'antd';

// Constants
import APP_URL from 'constants/ApplicationUrls';
import { NOTIFICATION_DURATION } from 'constants/General';

// Components
import PrivateRoute from 'components/PrivateRoute';
import Loading from 'components/Loading';

// Auth Components
import Login from 'components/Authentication/Login';
import ResetPassword from 'components/Authentication/ResetPassword';
import ForgotPassword from 'components/Authentication/ForgotPassword';
import LandingScreen from 'components/BaseLayout/LandingScreen';
import HelpOnTheWay from 'components/Authentication/HelpOnTheWay';

import CreateUserSignUp from 'components/Users/Public/SignUpUser';

// Localization
import LOCALIZATION from 'services/LocalizationService';

// Styling
import './assets/sass/style.scss';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import ReactStorageService from 'services/StorageService';

//hotjar
import Hotjar from "@hotjar/browser";

import {
  APP_ADMIN_HOT_JAR_ID,
  APP_ADMIN_HOT_VERSION,
} from "config/environment";

// Package.json
const packageJson = require('../package.json');

// Notification Configuration for whole application
notification.config({
  placement: 'topRight',
  duration: NOTIFICATION_DURATION,
  rtl: false
});

// Base Layout
const BaseLayout = Loadable({
  loader: () => import('components/BaseLayout'),
  loading: Loading
});

function App() {
  const dispatch = useDispatch();
  const { permissionLoading, permissionError } = useSelector((state) => state?.Auth);
  const getToken = ReactStorageService.instance.getAccessToken();
  const currentPath = window.location.pathname;
  const [isHotjarEnabled, setIsHotjarEnabled] = useState(true);

  useEffect(() => {
    if (!!APP_ADMIN_HOT_JAR_ID && isHotjarEnabled) {
      Hotjar.init(APP_ADMIN_HOT_JAR_ID, APP_ADMIN_HOT_VERSION, {
        debug: true,
      });
    }
  }, [isHotjarEnabled]);

  useEffect(() => {
    if (currentPath === APP_URL.LOGIN && isHotjarEnabled) {
      setIsHotjarEnabled(false);
      return;
    }

    if (isHotjarEnabled) return;
    setIsHotjarEnabled(true);
  }, [currentPath, isHotjarEnabled]);

  useEffect(() => {
    dispatch(userPermissions())
  }, [getToken]);

  if (permissionLoading) {
    <Loading />
  }
  if (!permissionLoading && permissionError) {
    return <>Roles are not assigned to the user</>
  }
  return (
    <div className={`App`}>
      <BrowserRouter basename={packageJson?.homepage || ''}>
        <Switch>
          {/* 
              Open Routes Here 
            */}
          {/* Login */}
          <Route
            path={APP_URL.LOGIN}
            name={LOCALIZATION.LOGIN}
            component={Login}
          />

          {/* Reset Password */}
          <Route
            path={APP_URL.RESET_PASSWORD}
            name={LOCALIZATION.RESET_YOUR_PASSWORD}
            component={ResetPassword}
          />

          {/* Forget Your Password */}
          <Route
            path={APP_URL.FORGOT_PASSWORD}
            name={LOCALIZATION.FORGOT_PASSWORD}
            component={ForgotPassword}
          />

          {/* Landing Screen */}
          <Route
            path={APP_URL.APP_LANDING_SCREEN}
            name={"Landing Screen"}
            component={LandingScreen}
          />

          {/* Help */}
          <Route
            path={APP_URL.FORGOT_PASSWORD_SUCCESS}
            name={"Help"}
            component={HelpOnTheWay}
          />

          <Route
            path={APP_URL.SIGN_UP}
            name={"Sign Up"}
            component={CreateUserSignUp}
          />

          {/* Restricted Routes Here */}
          <PrivateRoute
            component={BaseLayout}
          />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;